const getModelsQuery = /* GraphQL */ `
  query ($make: String) {
    models(make: $make) {
      makeId
      makeName
      models {
        modelId
        modelName
      }
    }
  }
`

export default getModelsQuery
